import { DistributionReason, TaxWithholding, TransferMechanism, CashDirection } from '../'

export interface ContributionTypeInfo {
  reason: IraContributionType
  previousYearContributionAllowed: boolean
}

export enum FeeInfoType {
  AchReturn = 'ACH_RETURN',
  AchReturnUnapproved = 'ACH_RETURN_UNAPPROVED',
  MicroReturn = 'MICRO_RETURN',
  MicroReturnUnapproved = 'MICRO_RETURN_UNAPPROVED',
  AchNocFee = 'ACH_NOC_FEE',
  MicroNocFee = 'MICRO_NOC_FEE',
  Closing = 'CLOSING',
  DomesticWire = 'DOMESTIC_WIRE',
  InternationalWire = 'INTERNATIONAL_WIRE',
  PrePay = 'PRE_PAY',
  AchReversalFee = 'ACH_REVERSAL_FEE',
  AchFee = 'ACH_FEE',
  MicroAchFee = 'MICRO_ACH_FEE',
  DebitCardTransFeeFixed = 'DEBIT_CARD_TRANS_FEE_FIXED',
  DebitCardTransFeePercent = 'DEBIT_CARD_TRANS_FEE_PERCENT',
  CheckRegularDelivery = 'CHECK_REGULAR_DELIVERY',
  CheckOvernightDelivery = 'CHECK_OVERNIGHT_DELIVERY',
  CheckSaturdayDelivery = 'CHECK_SATURDAY_DELIVERY',
  CheckOvernightToBroker = 'CHECK_OVERNIGHT_TO_BROKER',
  CheckInternationalOvernightDelivery = 'CHECK_INTERNATIONAL_OVERNIGHT_DELIVERY',
  CheckInternationalRegularDelivery = 'CHECK_INTERNATIONAL_REGULAR_DELIVERY',
  CheckPrintAtFirm = 'CHECK_PRINT_AT_FIRM',
  InternationalWireDeposit = 'INTERNATIONAL_WIRE_DEPOSIT',
  CheckStopPayment = 'CHECK_STOP_PAYMENT'
}

// TODO: Revisit
export enum IraContributionEnum {
  Regular = 'REGULAR',
  Employee = 'EMPLOYEE',
  Employer = 'EMPLOYER',
  Recharacterization = 'RECHARACTERIZATION',
  RolloverSixtyDay = 'ROLLOVER_60_DAY',
  RolloverDirect = 'ROLLOVER_DIRECT',
  Transfer = 'TRANSFER',
  TruteeFee = 'TRUSTEE_FEE',
  Conversion = 'CONVERSION'
}
export type IraContributionType =
  | 'REGULAR'
  | 'EMPLOYEE'
  | 'EMPLOYER'
  | 'RECHARACTERIZATION'
  | 'ROLLOVER_60_DAY'
  | 'ROLLOVER_DIRECT'
  | 'TRANSFER'
  | 'TRUSTEE_FEE'
  | 'CONVERSION'
  | 'REPAYMENT'

export type IraContribution = {
  type: IraContributionType
  applyToPriorYear?: boolean
}

export interface FeeInfo {
  type: FeeInfoType
  customerDebitAmount: number
  firmCreditAmount: number
  correspondentNetAmount: number
}

export interface DistributionReasonInfo {
  reason: DistributionReason
  withholdingEnabled: boolean
  stateWithholdingEnabled: boolean
}

export interface validContributions {
  reason: IraContributionType
  previousYearContributionAllowed: boolean
  previousYearDeadline?: string
}

export interface DistributionConstraints {
  totalDistributionAllowed: boolean
  closingFee?: FeeInfo
  validDistributionReasons: DistributionReasonInfo[]
}

export interface ContributionConstraints {
  onlyAllowCurrentYearContribution: boolean
  validContributions: validContributions[]
}

export interface RetirementConstraintsResponse {
  distributionConstraints: DistributionConstraints | null
  contributionConstraints: ContributionConstraints | null
  retirementAccount: boolean
}

export interface IraConstraintsResponsePayload {
  contributionConstraints?: ContributionConstraints
  distributionConstraints?: DistributionConstraints
  retirementAccount: boolean
}

export type IraContributionDetails = {
  type: IraContributionType
  applyToPriorYear: boolean
}

export type IraDistribution = {
  distributionReason: DistributionReason
  federalTaxWithholding?: TaxWithholding
  stateTaxWithholding?: TaxWithholding
  receivingInstitutionName?: string
  hasStateWithholdingWaiver?: boolean
}

export type IraDistributionDetails = {
  distributionReason: DistributionReason
  federalTaxWithholding?: TaxWithholding
  stateTaxWithholding?: TaxWithholding
  receivingInstitutionName?: string
  hasStateWithholdingWaiver?: boolean
}

export interface IraConstraintsRequestParams {
  account: string
  method: TransferMechanism
  direction: CashDirection
}
